import "../styles/TextInput.css";

const TextInput = ({ onChange }) => {
    return <input className="text-input" type="text" onChange={onChange}/>;
}

export default TextInput;
